import request from "../utils/request";

export const expressList = query =>{
    return request({
        url: "/express/expressList",
        method: "get",
        params: query
    });
}

// 获取自定义快递公司列表
export const queryPosExpress = query =>{
    return request({
        url: "/userFreightDiscount/queryPosExpress",
        method: "get",
        params: query
    });
}


// agentUserAddress/v2/recv_send_address 获取收寄件人信息列表
export const getAgentUserAddress = (data) => {
    return request({
        url: "/agentUserAddress/v2/recv_send_address_auth",
        method: "post",
        data
    });
}

// 单独保存
export const saveOrUpdatePkgInfoV3 = (data) => {
    return request({
        url: "express/saveOrUpdatePkgInfoV3",
        method: "post",
        data
    });
}

// @获取物品类型 GET
export const getPkgCategory = query =>{
    return request({
        url: "regin/getStantList",
        method: "get",
        params: query
    });
}

// @获取行政区域列表 GET
export const getReginListByKeyWords = searchKey =>{
    return request({
        url: "regin/getReginListByKeyWords?searchKey=" + searchKey,
        method: "get"
    });
}

// @当前收银台订单 GET
export const getPosRecentlyList = query =>{
    return request({
        url: "cashCounter/getPosRecentlyCashNum",
        method: "get",
        params: query
    });
}

// 单独保存
export const createCashNum = (data) => {
    return request({
        url: "cashCounter/createCashNum",
        method: "post",
        data,
        headers: {
            'Authorization': '1f55d1c564d442f38e4b8623c62fa3f3'
        },
    });
}

// 支付前计算价格
export const calculateOrderPayPriceByOrderIds = (data) => {
    return request({
        url: "cashCounter/calculateOrderPayPriceByOrderIds",
        method: "post",
        data,
    });
}

// 支付前计算价格
export const payOrderPriceBatch = (data) => {
    return request({
        url: "express/payOrderPriceBatch",
        method: "post",
        data,
    });
}


// @获取税务信息 GET
export const getTaxInfo = () =>{
    return request({
        url: "shop/tax/info",
        method: "get",
    });
}

// @获取cashNum下订单 GET
export const getPosDetailByCashNum = query =>{
    return request({
        url: "cashCounter/getPosDetailByCashNum",
        method: "get",
        params: query
    });
}

// @获取批量导入模版 GET
export const getExcelTemplate = () =>{
    return request({
        url: "express/getExcelTemplate",
        method: "get",
    });
}

// 批量导入
export const excelWithChannel = (data) => {
    return request({
        url: "pkg_car/importPos/excelWithChannel",
        method: "post",
        data,
    });
}


// 删除包裹
export const deleteExpressPkg = (data) => {
    return request({
        url: "express/deleteExpressPkg",
        method: "post",
        data,
    });
}

// 打印面单
export const printPkgWayBillV2 = (data) => {
    return request({
        url: "express/printPkgWayBill/V2",
        method: "post",
        data,
    });
}

// 商品列表
export const createCommodity = (data) => {
    return request({
        url: "shop/order/create",
        method: "post",
        data,
    });
}

// @删除商品订单 GET
export const DeleteCommodityOrder = searchKey =>{
    return request({
        url: "shop/order/remove?id=" + searchKey,
        method: "get"
    });
}

// 商品列表
export const editCommodityOrder = (data) => {
    return request({
        url: "shop/order/edit",
        method: "post",
        data,
    });
}

// @获取Cod信息 GET
export const getCodInfoList = query =>{
    return request({
        url: "user/cert/getCodInfoByMobileAndExpressCode",
        method: "get",
        params: query
    });
}

// @获取Cod信息 GET
export const querySupportInsureCompanyList = query =>{
    return request({
        url: "insurance/querySupportInsureCompanyList",
        method: "get",
        params: query
    });
}

// 商品列表
export const cashlist = (data) => {
    return request({
        url: "cashCounter/queryList",
        method: "post",
        data,
    });
}

// 自定义标准价列表
export const userDiscountInfoList = (data) => {
    return request({
        url: "userFreightDiscount/queryList",
        method: "post",
        data,
    });
}

// @删除自定义标准价 GET
export const delUserFreightDiscount = id =>{
    return request({
        url: "userFreightDiscount/disabled/" + id,
        method: "delete"
    });
}

// @获取Cod信息 GET
export const getExpressList = query =>{
    return request({
        url: "express/expressList",
        method: "get",
        params: query
    });
}

// 新增自定义标准价
export const addUserDiscountInfo = (data) => {
    return request({
        url: "userFreightDiscount/addDiscountInfo",
        method: "post",
        data,
    });
}

// 更新自定义标准价
export const updateUserDiscountInfo = (data) => {
    return request({
        url: "userFreightDiscount/update",
        method: "post",
        data,
    });
}

// @删除自定义标准价 GET
export const getRouteByExpressCode = id =>{
    return request({
        url: "userFreightDiscount/getRouteByExpressCode?expressCode=" + id,
        method: "get"
    });
}
// @删除自定义标准价 GET
export const userFreightDiscountDetail = id =>{
    return request({
        url: "userFreightDiscount/" + id,
        method: "get"
    });
}

// 获取商品分类列表
export const getCategoryList = (data) => {
    return request({
        url: "/shop/category/list",
        method: "post",
        data,
    });
}

// 获取商品分类列表
export const addAndUpdateCategory = (data) => {
    return request({
        url: "/shop/addCategory",
        method: "post",
        data,
    });
}


// 上传图片
export const uploadFile = (formData) => {
    return request({
        url: "/common/uploadFile",
        method: "post",
        data:formData,
    });
}

// @删除自定义标准价 GET
export const deleteCategory = id =>{
    return request({
        url: "/shop//category/remove?id=" + id,
        method: "get"
    });
}

// 获取分类所属商品
export const CommodityPage = (data) => {
    return request({
        url: "/shop/page",
        method: "post",
        data:data,
    });
}

// 新增分类所属商品
export const addCommodity = (data) => {
    return request({
        url: "/shop/add",
        method: "post",
        data:data,
    });
}

// 删除分类所属商品
export const deleteCommodity = id => {
    return request({
        url: "/shop/delete?id=" + id,
        method: "post",
    });
}
